import { styled } from '@mui/material/styles'
import { Box, Button, IconButton } from '@mui/material'
import Typography from '@mui/material/Typography'

export const StyledBox = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
  padding: '16px 0',
}))

export const StyledBoxOther = styled(Box)(() => ({
  alignItems: 'center',
  justifyContent: 'left',
  display: 'flex',
  flexDirection: 'row',
  width: '180px',
}))

export const StyledTypographyOther = styled(Typography)(() => ({
  fontWeight: 'Regular',
  fontFamily: 'Roboto',
  fontSize: '16px',
  lineHeight: '24px',
  color: 'black',
  wordBreak: 'break-all',
}))

export const StyledIconButtonOther = styled(IconButton)(() => ({
  border: '1px solid rgba(63, 81, 181, 0.5)',
  boxSizing: 'border-box',
  borderRadius: '4px',
  marginLeft: '8px',
  width: '36px',
  height: '36px',
}))

export const StyledTypography = styled(Typography)(() => ({
  minWidth: '180px',
  fontWeight: 'Regular',
  fontFamily: 'Roboto',
  fontSize: '14px',
  lineHeight: '14px',
  color: 'black',
}))

export const StyledTypographyUpload = styled(Typography)(() => ({
  marginLeft: '12px',
  fontStyle: 'normal',
  fontSize: 14,
  lineHeight: '24px',
}))
